import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-start-page",
  templateUrl: "./StartPage.html",
})
export class StartPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

}
